import React, { useEffect, useState } from "react";
import { Box, Grid } from "@material-ui/core";
import FormBase from "../../../../forms/FormBase";
import VocationalTraningForm, { VocationalTraningFormItem } from "../../../../forms/shared/VocationalTraningForm";
import Controls from "../../../../components/controls/Controls";

import AcademicService from "../../../../services/AcademicService";
import { ITableHeaderProps } from "../../../../components/controls/Table";
import { InputType } from "../../../../components/controls/Input";


interface VocationalTraningComponentProps {
    VocationalTraningForm: VocationalTraningForm,
    onInputChange: (name: string, form: FormBase, value: any) => void
    onInserOrUpdateItem: () => void
    onEditClick: (e: VocationalTraningFormItem) => void
    onDeleteClick: (e: VocationalTraningFormItem) => void
    onCancelItem: () => void
}

export default function VocationalTraningComponent(props: VocationalTraningComponentProps) {

    const headers: ITableHeaderProps[] = [
        { title: "Especialidade", align: "left", property: "Expertise", type: "text" },
        { title: "Data de Obtenção", align: "center", property: "DateAcquisition", type: "date" },
        { title: "Título de Especialidade", align: "center", property: "Title", type: "text" },
        { title: "Instituição", align: "center", property: "Institution", type: "text" },
        { title: "Ano de conclusão", align: "center", property: "YearCompletion", type: "text" },
        { title: "Área de Atuação", align: "center", property: "OperationArea", type: "text" },
    ]

    const [specialtyStateOptions, setSpecialtyStateOptions] = useState([])
    const [titleStateOptions, setTitleStateOptions] = useState([])
    const [operationAreaStateOptions, setOperationAreaStateOptions] = useState([])

    useEffect(() => {
        AcademicService.getAllSpecialtyOptions().then(e => setSpecialtyStateOptions(e))
        AcademicService.getAllTitleOptions().then(e => setTitleStateOptions(e))
        AcademicService.getAllOperationAreaOptions().then(e => setOperationAreaStateOptions(e))
    }, []);


    return (

        <Grid container spacing={5}>
            <Grid item xs={6} sm={6}>
                <Controls.Autocomplete
                    label="Especialidade *"
                    name="Expertise"
                    placeholder="Selecione"
                    options={specialtyStateOptions}
                    value={props.VocationalTraningForm.Expertise.Value}
                    onChange={(e) => {
                        props.onInputChange("Expertise", props.VocationalTraningForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("Expertise", props.VocationalTraningForm, e.target.value);
                    }}
                    error={props.VocationalTraningForm.Expertise.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.DatePicker
                    name="DateAcquisition"
                    label="Data de obtenção *"
                    value={props.VocationalTraningForm.DateAcquisition.Value}
                    onChange={(e) => {
                        props.onInputChange("DateAcquisition", props.VocationalTraningForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("DateAcquisition", props.VocationalTraningForm, e.target.value);
                    }}
                    error={props.VocationalTraningForm.DateAcquisition.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.Autocomplete
                    label="Título de Especialidade *"
                    name="Title"
                    placeholder="Selecione"
                    options={titleStateOptions}
                    value={props.VocationalTraningForm.Title.Value}
                    onChange={(e) => {
                        props.onInputChange("Title", props.VocationalTraningForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("Title", props.VocationalTraningForm, e.target.value);
                    }}
                    error={props.VocationalTraningForm.Title.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.Input
                    name="Institution"
                    label="Instituição *"
                    maxLength={80}
                    placeholder="Digite o nome da instituição"
                    value={props.VocationalTraningForm.Institution.Value}
                    onChange={(e) => {
                        props.onInputChange("Institution", props.VocationalTraningForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("Institution", props.VocationalTraningForm, e.target.value);
                    }}
                    error={props.VocationalTraningForm.Institution.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.Input
                    name="YearCompletion"
                    label="Ano de conclusão *"
                    maxLength={4}
                    type={InputType.NUMERICO}
                    placeholder="Digite o ano de conclusão"
                    value={props.VocationalTraningForm.YearCompletion.Value}
                    onChange={(e) => {
                        props.onInputChange("YearCompletion", props.VocationalTraningForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("YearCompletion", props.VocationalTraningForm, e.target.value);
                    }}
                    error={props.VocationalTraningForm.YearCompletion.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.Autocomplete
                    label="Área de Atuação"
                    name="OperationArea"
                    placeholder="Selecione"
                    mandatory={props.VocationalTraningForm.OperationArea.Mandatory}
                    options={operationAreaStateOptions}
                    value={props.VocationalTraningForm.OperationArea.Value}
                    onChange={(e) => {
                        props.onInputChange("OperationArea", props.VocationalTraningForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("OperationArea", props.VocationalTraningForm, e.target.value);
                    }}
                    error={props.VocationalTraningForm.OperationArea.Error}
                />
            </Grid>

            <Grid item xs={12}>
                <Box style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>

                    {(props.VocationalTraningForm.VocationalTraningFormItemToEdit.Id > 0 ?
                        <Controls.Button text="Cancelar" type="Error" onClick={props.onCancelItem} /> : null
                    )}

                    {(props.VocationalTraningForm.VocationalTraningFormItemToEdit.Id === 0 ?
                        <Controls.Button text="Adicionar" type="Success" onClick={props.onInserOrUpdateItem} />
                        : <Controls.Button text="Salvar" type="Success" onClick={props.onInserOrUpdateItem} />
                    )}

                </Box>
            </Grid>

            <Grid item xs={12}>
                <Controls.Table
                    headers={headers}
                    actionColumn={true}
                    onDeleteClick={props.onDeleteClick}
                    onEditClick={props.onEditClick}
                    rows={props.VocationalTraningForm.VocationalTraningFormItemList}
                />
            </Grid>

        </Grid>

    )

}